import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

var Azure_Devops_Send = View.extend({
    projects        : [],
    work_item_types : {},

    project_id      : null,
    work_item_type  : null,
    tags            : [],

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-project li'          : 'onSelectProject',
        'click .dropdown-work-item-type li'   : 'onSelectWorkItemType',
        'click .dropdown-tag li'              : 'onSelectTag',
        'click .dropdown-tag .badge-btn .btn' : 'onRemoveTag',
        'submit form'                         : 'onSubmit',
        'click .reconnect'                    : 'onReconnect'
    },

    dom_handlers: {
        onSelectProject: function(e) {
            var project_id = $(e.currentTarget).data('key');

            if (project_id != this.project_id) {
                this.project_id = project_id;

                // don't validate when not loaded
                // loadWorkItemTypes sets work_item_type on success
                if (this.work_item_types[this.project_id]) {
                    var work_item_type = this.searchWorkItemType(this.project_id, this.work_item_type);
                    if (!work_item_type) {
                        this.work_item_type = this.work_item_types[this.project_id][0].name;
                    }
                }

                this.renderProjects();
                this.renderWorkItemTypes();

                if (!this.work_item_types[this.project_id]) {
                    this.loadWorkItemTypes(this.project_id);
                }
            }
        },

        onSelectWorkItemType: function(e) {
            var work_item_type = $(e.currentTarget).data('key');

            if (work_item_type != this.work_item_type) {
                this.work_item_type = work_item_type;
                this.renderWorkItemTypes();
            }
        },

        onSelectTag: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var tag = $(e.currentTarget).data('key');

            this.tags.push(tag);
            this.renderTags();
        },

        onRemoveTag: function(e) {
            e.stopPropagation();

            var tag = $(e.currentTarget).data('key');
            var index = this.tags.indexOf(tag);

            if (index !== -1) {
                this.tags.splice(index, 1);
                this.renderTags();
            }
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            var progress = 0;
            var timeout = setInterval(() => {
                progress = Math.min(90, progress + Math.random() * 15);
                this.$el.find('.progress-loader').width(progress + '%');
            }, 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToAzureDevops',
                context: this,
                data: _.extend(form_data, {
                    feedback_id    : this.model.get('id'),
                    project_id     : this.project_id,
                    work_item_type : this.work_item_type,
                    tags           : this.tags
                }),
                success: function(response) {
                    this.model.set('azure_devops_url', response.azure_devops_url);

                    setTimeout(() => {
                        UI.success('Work item created in Azure DevOps');
                        this.trigger('submit:success');
                    }, 800);  // wait for animation to finish
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                },
                error: function() {
                    this.$el.find('.mask-light').hide();
                    this.$el.find('.progress-loader').hide();

                    UI.error('Couldn\'t create "' + this.work_item_type + '". Please select a different work item type.');
                }
            });
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_oauth.get(Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToAzureDevops(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        }
    },

    initialize: function() {
        this.form_value  = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = 'Feedback for ' + this.model.get('page');
        } else {
            this.title = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }

        this.projects        = [];
        this.work_item_types = {};
        this.tags            = [];

        this.project_id     = Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')})?.get('azure_devops_project_id') || '';
        this.work_item_type = Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')})?.get('work_item_type') || '';

        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach((category_name) => {
                this.tags.push(Util.removeEmoji(category_name));
            });
        }
    },

    searchProject: function(project_id) {
        var result = null;

        this.projects.forEach(function(option) {
            if (option.id == project_id) {
                result = option;
            }
        });

        return result;
    },

    searchWorkItemType: function(project_id, work_item_type) {
        var result = null;

        if (this.work_item_types[project_id]) {
            this.work_item_types[project_id].forEach(function(option) {
                if (option.name == work_item_type) {
                    result = option;
                }
            });
        }

        return result;
    },

    loadProjects: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type         : 'azure_devops_projects',
                project_id   : this.model.get('project_id'),
                account_name : Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')}).get('azure_devops_account_name')
            },
            context: this,
            success: function(response) {
                if (response && response.length) {
                    this.projects = response;

                    var project = this.searchProject(this.project_id);
                    if (!project) {
                        this.project_id = response.length ? response[0].id : null;
                    }

                    this.renderProjects();
                    this.loadWorkItemTypes(this.project_id);
                } else {
                    this.renderError();
                }
            },
            error: function() {
                this.renderError();
            }
        });
    },

    loadWorkItemTypes: function(project_id) {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type         : 'azure_devops_project_items',
                project_id   : this.model.get('project_id'),
                account_name : Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')}).get('azure_devops_account_name'),
                azure_project_id : project_id
            },
            context: this,
            success: function(response) {
                if (response && response.work_item_types.length) {
                    this.work_item_types[project_id] = response.work_item_types;

                    var work_item_type = this.searchWorkItemType(this.project_id, this.work_item_type);
                    if (!work_item_type) {
                        this.work_item_type = response.work_item_types.length ? responsework_item_types[0].name : null;
                    }

                    this.renderWorkItemTypes();
                }
            }
        });
    },

    renderProjects: function() {
        var project_items = '';
        var project = this.searchProject(this.project_id);

        this.projects.forEach((option) => {
            project_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.project_id ? ' class="selected"' : '') + '>' +
                                 Util.htmlEntities(option.name) +
                             '</li>';
        });

        this.$el.find('.region-projects').html(
            '<div class="field-label">Project <i class="fas fa-asterisk"></i></div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-project" data-append="true">' +
                '<button type="button" class="dropdown-select">' +
                    (project ? Util.htmlEntities(project.name) : '<span class="placeholder-text">No project selected</span>') +
                '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by project name">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-select">' + project_items + '</ul>' +
                '</div>' +
            '</div>'
        );
    },

    renderWorkItemTypes: function() {
        if (this.work_item_types[this.project_id]) {
            var work_item_type_items = '';
            var work_item_type = this.searchWorkItemType(this.project_id, this.work_item_type);

            this.work_item_types[this.project_id].forEach((option) => {
                work_item_type_items += '<li data-key="' + Util.htmlEntities(option.name) + '"' + (option.name == this.work_item_type ? ' class="selected"' : '') + '>' +
                                            '<img class="icon-img" src="' + option.icon + '">' +
                                            Util.htmlEntities(option.name) +
                                        '</li>';
            });

            this.$el.find('.region-work-item-types').html(
                '<div class="field-label">Work item type <i class="fas fa-asterisk"></i></div>' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-work-item-type" data-append="true">' +
                    '<button type="button" class="dropdown-select">' +
                        (work_item_type ? '<img class="icon-img" src="' + work_item_type.icon + '">' + Util.htmlEntities(work_item_type.name) : '<span class="placeholder-text">No work item type selected</span>') +
                    '</button>' +
                    '<div>' +
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search by work item type name">' +
                        '</div>' +
                        '<ul class="dropdown dropdown-select">' + work_item_type_items + '</ul>' +
                    '</div>' +
                '</div>');

            this.$el.find('form button:submit').prop('disabled', work_item_type ? false : true);
        } else {
            this.$el.find('.region-work-item-types').html(
                '<div class="field-label">Work item type <i class="fas fa-asterisk"></i></div>' +
                '<div class="loader-placeholder loader-placeholder-medium"></div>'
            );

            this.$el.find('form button:submit').prop('disabled', false);
        }
    },

    renderTags: function() {
        var categories = '';
        var category_items = '';

        this.tags.forEach(function(tag) {
            categories += '<span class="badge-secondary-invert badge-btn">' +
                              '<span>' + Util.htmlEntities(tag) + '</span>' +
                              '<span type="button" class="btn" data-key="' + Util.htmlEntities(tag) + '"><i class="far fa-times"></i></span>' +
                          '</span>';
        });

        Cache.feedback_category.where({project_id: this.model.get('project_id')}).forEach((model) => {
            if (this.tags.indexOf(model.get('name')) === -1) {
                var tag_name = Util.removeEmoji(model.escape('name'));

                category_items += '<li data-key="' + tag_name + '">' +tag_name + '</li>';
            }
        });

        if (!category_items) {
            category_items = '<li class="disabled">No matches</li>';
        }

        this.$el.find('.region-tags').html(
            '<div class="field-label">Tags</div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-multiple button-dropdown-left dropdown-tag" data-append="true">' +
                '<button type="button" class="dropdown-select">' + categories + '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by category name">' +
                    '</div>' +
                    '<ul class="dropdown">' + category_items + '</ul>' +
                '</div>' +
            '</div>');
    },

    renderError: function() {
        var html = '<div class="error-dialog padding-50">' +
                        '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                        '<h3>Authentication failed</h3>' +
                        '<p class="info">Your Azure DevOps account couldn\'t be connected.</p>' +
                        '<button class="reconnect primary medium">Reconnect Azure DevOps</button>' +
                    '</div>';

        this.$el.html(html);
    },

    render: function() {
        var content = '';

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row-50">' +
                                '<div class="region-projects">' +
                                    '<div class="field-label">Project <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                                '<div class="region-work-item-types">' +
                                    '<div class="field-label">Work item type <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Title</div>' +
                                '<input type="text" name="title" maxlength="255" class="solid compact" placeholder="' + Util.htmlEntities(this.title) + '">' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="4"></textarea>' +
                            '</div>' +
                            '<div class="row region-tags">' +
                                '<div class="field-label">Tags</div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary" disabled>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        this.loadProjects();
        this.renderTags();

        return this;
    }
});

export default Azure_Devops_Send;